<template>
	<div class="order-item img-border flex center">
		<!-- 图标 -->
		<div class="flex-item order-item-icon"
		    :style="iconStyle"></div>
		<!-- New -->
		<div v-if="order.orderStatus == 1"
		    class="order-item-new">NEW</div>
		<div class="flex column">
			<!-- 标题 -->
			<div class="flex">
				<div class="th col1">服务类别</div>
				<div class="th col2">报单人</div>
				<div class="th col3">执行人</div>
				<div class="th col4">要求完成时间</div>
				<div class="th col5">状态</div>
			</div>
			<!-- 内容 -->
			<div class="flex">
				<div class="td col1">{{ serviceTypeName }}</div>
				<div class="td col2">{{ order.createUserName }}</div>
				<div class="td col3">{{ order.execUserName }}</div>
				<div class="td col4">{{ order.planCompleteTime | ymdL }}</div>
				<div class="td col5">
					<span :class="'order-status-color' + order.orderStatus">{{ orderStatusname }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Enum from '_u/enum'

const SERVICE_TYPE = Enum.get("SERVICE_TYPE")

export default {
	name: "OrderItem",

	props: {
		order: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			orderStatus: this.$dict.NULL,
		}
	},

	computed: {
		iconStyle() {
			return {
				background: `url(${SERVICE_TYPE.getMeta(this.order.serviceType).img}) no-repeat center`,
				'background-size': 'cover',
			}
		},

		serviceTypeName() {
			return SERVICE_TYPE.getName(this.order.serviceType)
		},

		orderStatusname() {
			return this.orderStatus.val(this.order.orderStatus)
		}
	},

	created() {
		this.$dict.get('order_status').then(dict => {
			this.orderStatus = dict
		})
	},
}
</script>
<style lang="less"
    scoped>
.order-item {
	position: relative;
	box-sizing: border-box;
	background-color: rgba(2, 36, 125, 0.3);
	border: solid 2px rgba(29, 55, 122, 0.3);
	margin-bottom: 15px;
	cursor: pointer;

	&-icon {
		width: 53px;
		height: 53px;
		border-radius: 8px;
	}

	&-new {
		position: absolute;
		top: -12px;
		right: -10px;
		width: 60px;
		height: 24px;
		line-height: 24px;
		border-radius: 0 8px 0 8px;
		text-align: center;
		font-size: 14px;
		background-color: red;
		color: #fff;
	}
}

.col1 {
	width: 118px;
}

.col2 {
	width: 140px;
}

.col3 {
	width: 100px;
}

.col4 {
	width: 216px;
}

.col5 {
	width: 78px;
}

.th {
	margin-top: 15px;
	margin-bottom: 13px;
	line-height: 15px;
	font-size: 15px;
	color: #9fdae5;
}

.td {
	margin-bottom: 17px;
	line-height: 18px;
	font-size: 18px;
	color: #fff;
}
</style>